import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { FiMenu, FiX } from 'react-icons/fi';
import logo from '../assets/nice.png';
import myCV from '../assets/Oktaryan Hugo Wiratama-resume.pdf'; 
import { AnimatePresence, motion } from 'framer-motion';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize(); // inisialisasi saat mount
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const menuItems = [
    { to: 'home', label: 'Home', colorHex: '#8C6D5A' },
    { to: 'about', label: 'About Me', colorHex: '#8C6D5A' },
    { to: 'experiences', label: 'Experiences', colorHex: '#8C6D5A' },
    { to: 'services', label: 'Services', colorHex: '#8C6D5A' },
    { to: 'recent-works', label: 'Recent Works', colorHex: '#8C6D5A' },
    { to: 'certificates', label: 'Certificates', colorHex: '#8C6D5A' },
    { to: 'contact', label: 'Get in Touch', colorHex: '#8C6D5A' },
  ];

  const getOffset = () => (isMobile ? 0 : -30);

  return (
    <motion.nav
      initial={{ y: 0 }}
      animate={{ y: 0 }}
      className="fixed top-0 left-0 w-full z-50 bg-[#F5F3EF] bg-opacity-30 backdrop-blur-md border border-[#D9CFC2] text-[#5e4b45] px-5 py-2 shadow"
    >
      <div className="flex justify-between items-center max-w-7xl mx-auto md:text-center">
        <div className="flex items-center space-x-2">
          <Link
            to="home"
            smooth={true}
            duration={500}
            offset={getOffset()}
            className="cursor-pointer"
          >
            <img src={logo} alt="Logo" className="w-12 h-12 md:w-14 md:h-14 rounded-lg" />
          </Link>        
        </div>
        {/* Desktop menu */}
        <div className="hidden md:flex space-x-6 items-center md:ml-10">
          {menuItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              smooth={true}
              duration={500}
              offset={getOffset()}
              className="cursor-pointer font-semibold text-[#4B4033] hover:text-[#7B5E4C] transition duration-300 border-b-2 border-transparent hover:border-[#8C6D5A] pb-1"
            >
              {item.label}
            </Link>
          ))}

          <motion.a
            href={myCV}
            download
            whileHover={{
              scale: 1.07,
              transition: { type: 'spring', stiffness: 300 }
            }}
            className="ml-4 px-4 py-2 bg-[#8C6D5A] hover:bg-[#7B5E4C] text-white text-sm font-semibold rounded-lg cursor-pointer"
          >
            My Resume
          </motion.a>
        </div>

        {/* Mobile menu button */}
        <div className="md:hidden relative w-8 h-8 cursor-pointer" onClick={toggleMenu}>
          <motion.div
            key={isOpen ? 'close' : 'menu'}
            initial={{ rotate: -90, scale: 0.8, opacity: 0 }}
            animate={{ rotate: 0, scale: 1, opacity: 1 }}
            exit={{ rotate: 90, scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="absolute top-0 left-0 w-8 h-8"
          >
            {isOpen ? <FiX size={32} /> : <FiMenu size={32} />}
          </motion.div>
        </div>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            key="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="flex flex-col mt-4 space-y-4 md:hidden overflow-hidden px-4 pb-4"
          >
            {menuItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                smooth={true}
                duration={500}
                offset={getOffset()}
                onClick={() => setIsOpen(false)}
                className="cursor-pointer font-semibold text-[#4B4033] hover:text-[#7B5E4C] transition duration-300 border-b-2 border-transparent hover:border-[#8C6D5A] pb-1"
              >
                {item.label}
              </Link>
            ))}

            <motion.a
              href={myCV}
              download
              whileHover={{
                scale: 1.07,
                transition: { type: 'spring', stiffness: 300 }
              }}
              className="block text-left mt-2 px-4 py-2 w-fit bg-[#8C6D5A] hover:bg-[#7B5E4C] text-white font-semibold rounded-lg cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              My Resume
            </motion.a>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default Navbar;